import { useParams } from "react-router-dom"

import { ApplySettings, useSettings } from "settings"

import { OnboardPatient } from "./OnboardPatient"

const OnboardContainer = () => {
  const { practiceIdentifier, personIdentifier } = useParams()

  if (!practiceIdentifier) {
    throw new Error("Unauthorized", {
      cause: {
        name: "401",
        message: "Sorry, you don't shall pass. If you think it is a mistake, contact to support.",
      },
    })
  }

  const { settings } = useSettings(practiceIdentifier)

  return (
    <>
      <ApplySettings settings={settings} />
      <OnboardPatient settings={settings} practiceIdentifier={practiceIdentifier} personIdentifier={personIdentifier} />
    </>
  )
}

export { OnboardContainer }
